import { render, staticRenderFns } from "./TotalCosts.vue?vue&type=template&id=266cfa8e"
import script from "./TotalCosts.vue?vue&type=script&lang=js"
export * from "./TotalCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports